"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SURVEY_QUESTION_KIND = void 0;
var SurveyQuestionKind;
(function (SurveyQuestionKind) {
    SurveyQuestionKind["MULTIPLE_CHOICE"] = "MULTIPLE_CHOICE";
    SurveyQuestionKind["RANGE"] = "RANGE";
})(SurveyQuestionKind || (SurveyQuestionKind = {}));
exports.SURVEY_QUESTION_KIND = Object.values(SurveyQuestionKind);
exports.default = SurveyQuestionKind;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU3VydmV5UXVlc3Rpb25LaW5kLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2VudW1zL1N1cnZleVF1ZXN0aW9uS2luZC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSxJQUFLLGtCQUdKO0FBSEQsV0FBSyxrQkFBa0I7SUFDckIseURBQW1DLENBQUE7SUFDbkMscUNBQWUsQ0FBQTtBQUNqQixDQUFDLEVBSEksa0JBQWtCLEtBQWxCLGtCQUFrQixRQUd0QjtBQUVZLFFBQUEsb0JBQW9CLEdBQUcsTUFBTSxDQUFDLE1BQU0sQ0FBQyxrQkFBa0IsQ0FBQyxDQUFDO0FBRXRFLGtCQUFlLGtCQUFrQixDQUFDIn0=